import React from 'react';
import { LiliButton } from '@lili/lili-frontend-common';
import Heading from '../../generic-components/Heading';
import ErrorIcon from '../../assets/icons/svg/stamp-icons/ic-stamp-alert-triangle.svg';
import Icon from '../../generic-components/Icon';
import { STYLES } from './constants';

interface IProps{
    title: string
    description: string
    buttonTitle: string
    onActionClick: () => void
}
export const GenericErrorModal = ({
  title, description, buttonTitle, onActionClick,
}: IProps) => (
  <div id='planErrorModal' className={STYLES.ERROR_MODAL.LAYOUT}>
    <Icon
      src={ErrorIcon}
    />
    <div className='flex flex-col items-center'>
      <Heading
        title={title}
        className={STYLES.ERROR_MODAL.TITLE}
      />
      <Heading
        title={description}
        className={STYLES.ERROR_MODAL.SUBTITLE}
      />
    </div>
    <LiliButton
      className={STYLES.ERROR_MODAL.BUTTON}
      id='d'
      title={buttonTitle}
      onClick={onActionClick}
    />
  </div>

);
